export default __webpack_public_path__ + "static/media/ic_scholarship.db59900c.svg";